import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import FormControl from '@material-ui/core/FormControl';
import { DatePicker } from '@material-ui/pickers';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
  formContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  formControl: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: theme.spacing(1),
    minWidth: 120
  }
}));

const VipRangeEditModal = ({
  visible,
  close,
  gradePeriod,
  updateGradePeriod,
  removeGradePeriod
}) => {
  const classes = useStyles();
  const [start, setStart] = useState(Date.now());
  const [end, setEnd] = useState(Date.now());

  useEffect(() => {
    if (gradePeriod) {
      setStart(gradePeriod.start);
      setEnd(gradePeriod.end);
    }
  }, [gradePeriod]);

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      open={visible}
      onClose={close}
    >
      <DialogContent>
        <div className={classes.formContainer}>
          <FormControl variant="outlined" className={classes.formControl}>
            <DatePicker
              disablePast
              id="start-date"
              label="시작일"
              type="date"
              value={start}
              labelFunc={date => date.format('YYYY-MM-DD')}
              onChange={date => setStart(date.valueOf())}
              InputLabelProps={{ shrink: true }}
            />
          </FormControl>
          <FormControl variant="outlined" className={classes.formControl}>
            <DatePicker
              disablePast
              minDate={moment(start).format('YYYY-MM-DD')}
              id="end-date"
              label="종료일"
              type="date"
              value={end}
              labelFunc={date => date.format('YYYY-MM-DD')}
              onChange={date => setEnd(date.valueOf())}
              InputLabelProps={{ shrink: true }}
            />
          </FormControl>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="primary">
          {'취소'}
        </Button>
        <Button
          onClick={() => {
            removeGradePeriod();
            close();
          }}
          color="secondary"
        >
          {'제거'}
        </Button>
        <Button
          onClick={() => {
            updateGradePeriod({ start: start.valueOf(), end: end.valueOf() });
            close();
          }}
          color="primary"
        >
          {'확인'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VipRangeEditModal;
